<!--  HOME PAGE -->

<template lang="html">
  <div class="home-container">
    <mast-head ref="masthead"> </mast-head>
    <section id="projects-container" class="section-no-pad">
      <div v-for="(project, index) in homeprojects">
        <router-link :to="'/project/' + project.url">
          <div class="home-project-entry active">
            <div class="home-project-entry-bg"></div>
            <transition name="fade" mode="out-in">
              <img
                v-if="imagetype == 'desktop'"
                :src="'static/img/content/' + project.thumb"
                v-show="project.loaded"
                @load="project.loaded = true"
              />
              <img
                v-if="imagetype == 'mobile'"
                :src="'static/img/content/' + project.thumb_mobile"
                v-show="project.loaded"
                @load="project.loaded = true"
              />
            </transition>

            <div
              class="home-project-entry-overlay"
              v-show="project.loaded"
            ></div>
            <div class="home-project-title" v-show="project.loaded">
              <h2>{{ project.title }}</h2>
              <hr />
              <label>{{ project.homesub }} </label>
            </div>

            <div class="home-project-entry-loader" v-show="!project.loaded">
              <div
                class="home-project-entry-loader-block home-project-entry-loader-block-orange"
              ></div>
              <div
                class="home-project-entry-loader-block home-project-entry-loader-block-outline"
              ></div>
            </div>
          </div>
        </router-link>
        <section class="name-section name-section-small">
          <div class="name-section-inner name-section-inner-black"></div>
        </section>
      </div>
    </section>
  </div>
</template>

<style></style>

<script>
import { home, projects } from "../../content.json";
import { commontools } from "../mixins/Styling";
import MastHead from "../components/MastHead";
import Vue from "vue";
import VueLazyload from "vue-lazyload";

Vue.use(VueLazyload, {
  observer: true,
  throttleWait: 2000,
  // optional
  observerOptions: {
    rootMargin: "0px",
    threshold: 0.1,
  },
  lazyComponent: true,
});

export default {
  name: "home",
  mixins: [commontools],
  data: function () {
    return {
      home,
      homeprojects: [],
      projectcounter: 0,
      projects: [],
      scrollY: 0,
      percentScroll: 0,
      imagetype: null,
    };
  },
  methods: {
    scrollToDiv(_div) {
      var top = document.getElementById(_div).offsetTop;
      window.scrollTo(0, top - 43);
    },
    handleScroll() {
      this.scrollY = window.scrollY;
      let myheight = window.innerHeight;
      this.$refs.masthead.handleScroll(this.scrollPercent());

      let bottomOfWindow =
        window.scrollY + window.innerHeight >=
        document.documentElement.offsetHeight - 300;

      if (bottomOfWindow) {
        this.addProjects();
      }
    },
    addProjects: function () {
      let target = this.projectcounter + 3;

      if (this.projectcounter >= this.projects.length) return;

      for (var i = this.projectcounter; i < target; i++) {
        this.homeprojects.push(this.projects[this.projectcounter]);
        this.projectcounter++;
        if (this.projectcounter >= this.projects.length) break;
      }
    },
    getProjectThumb: function () {
      this.imagetype = window.innerWidth <= 575 ? "mobile" : "desktop";
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.getProjectThumb);
    window.scrollTo(0, 0);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.getProjectThumb);
  },
  mounted: function () {
    this.mastheight = window.innerHeight;
    this.projects = projects;
    this.projects.map((project) => {
      Vue.set(project, "loaded", false);
    });

    this.addProjects();
    this.getProjectThumb();
    this.handleScroll();
  },
  components: {
    MastHead,
  },
};
</script>
